var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2160 830",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-9{fill:none;}.cls-2{fill:#f4f7fa;}.cls-3{opacity:0.81;}.cls-12,.cls-18,.cls-4{fill:#fff;}.cls-16,.cls-5{fill:#29abe2;}.cls-15,.cls-5{opacity:0.39;}.cls-6,.cls-8{fill:#e6e6e6;}.cls-7{fill:#b3b3b3;}.cls-8,.cls-9{stroke:#f4f7fa;stroke-miterlimit:10;}.cls-9{stroke-width:3px;}.cls-10{fill:#ccc;}.cls-11{fill:#999;}.cls-12{opacity:0.21;}.cls-13{fill:#0071bc;}.cls-14{clip-path:url(#clip-path);}.cls-17{clip-path:url(#clip-path-2);}.cls-18{opacity:0.8;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID",
    className: "cls-1",
    d: "M313.54,274.77l4.17,55,138.83-5q-2.62-35-5.26-70c-38-16.17-58.59-13.66-70.36-8.19-13.25,6.15-20.27,18.33-42.66,24.73A92,92,0,0,1,313.54,274.77Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-2",
    "data-name": "SVGID",
    className: "cls-1",
    d: "M918.05,523.27c12.57-9.68,23-11.93,30.48-12.07,9.43-.18,12.69,3,22.79,1.34,10.28-1.74,10.79-5.75,22.25-8.11a62,62,0,0,1,22.41-.17c13.46,2.35,14.33,7.17,22.47,6.5,7.51-.61,7.76-4.8,22.17-12,6.8-3.39,13.14-6.55,21.77-7.68,9.39-1.23,10.26,1.43,22.25.76a90.76,90.76,0,0,0,21.48-4c12.53-3.69,14-6.59,22.49-8.24,5.05-1,12.8-1.56,23.05,1.31l4.68,64.71L921.28,563.15Q919.66,543.22,918.05,523.27Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1235,129h6l38.34,525.48c.57,15.85-5.4,30-28.34,28.52h-2l-6-1c21-4,27-13,29-25l-42-528Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "846.99 326.58 526.3 338.7 526.76 344.75 847.42 332.38 846.99 326.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "707.66 176.51 719.46 335.62 725.45 335.39 713.66 176.4 707.66 176.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M681.66,368.67l-113.43,4.8a1,1,0,0,1-1-.89l-.76-10.18a.91.91,0,0,1,.89-1l113.44-4.63a1,1,0,0,1,1,.88l.74,10A.89.89,0,0,1,681.66,368.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M713.57,389.86l-143.63,6.48a1,1,0,0,1-1-.88l-.76-10.18a.91.91,0,0,1,.89-1L712.69,378a1,1,0,0,1,1,.87l.74,10A.88.88,0,0,1,713.57,389.86Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "821.05 228.99 734.11 231.19 731.6 197.27 818.58 195.44 821.05 228.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "827 309.71 740.16 312.8 735.18 245.63 822.1 243.28 827 309.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M614.3,236c13.62-.35,25.47,10.12,26.46,23.34a22.77,22.77,0,0,1-1.68,10.42L668.8,282a52.19,52.19,0,0,0,3.64-23.56c-2.24-30.18-29.27-54.2-60.46-53.53h-.24L614.06,236Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M639.08,269.76a23.46,23.46,0,0,1-21.2,14.31c-13.66.43-25.62-10-26.61-23.32s9.24-24.26,22.79-24.73l-2.32-31.11c-31.32.81-55.08,26.22-52.8,56.76s29.87,54.59,61.26,53.48c22.54-.79,41-14.33,48.6-33.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M111.32,783.68c-30.91,2.69-45.68-13.54-46.85-28.8l-45-611.54.17-50a64.07,64.07,0,0,1,.14-10.38l20.94,62,47,612c1.13,14.71,14.46,25.82,30.27,25.89l-6.71.87,1.47-.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1241.18,128.79l-38.33-58.42c-1-13.43-12.21-24.4-11-29.69L57.63,43.35C17.93,46.67,12.53,70,13.72,85.61l5.5,63.56,21.12-4.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1279.1,655.82c1,13.51-8.7,25.48-21.53,26.61L120.75,782.37c-17.14,1.51-32.19-10.08-33.4-25.76l-47-612,3.08-71.93c-1.21-15.76,5.42-24.55,22.72-24.58l1145.08-7.65c13,0,24.31,11.08,25.28,24.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1241.1,128.74l-4.59-63.68c-1-13.57-12.33-24.66-25.28-24.65L64,41.9c-17.3,0-30.52,12.94-29.31,28.7l5.68,74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M114.41,94.11c.6,7.81-5.83,14.19-14.38,14.27s-16-6.21-16.6-14S89.3,80.13,97.87,80.08,113.82,86.31,114.41,94.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M180.92,93.62c.59,7.74-5.74,14.08-14.16,14.16S151,101.62,150.41,93.85s5.78-14.11,14.21-14.16S180.33,85.88,180.92,93.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M246.4,93.14c.58,7.68-5.65,14-13.94,14s-15.51-6.11-16.1-13.82,5.68-14,14-14S245.81,85.46,246.4,93.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M542.24,419.49c-8.79.37-16.45-6.21-17.08-14.72L509.53,196.2a14.49,14.49,0,0,1,3.75-11,15.64,15.64,0,0,1,11.28-5l291.67-5.39a16,16,0,0,1,16,14.64l14.77,200.42a14.61,14.61,0,0,1-13.95,15.75L542.33,419.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1167.72,389.22l-266,12.64a13.47,13.47,0,0,1-14-12.47L873.11,190.07a12.26,12.26,0,0,1,12.07-13.35l266.8-4.93c6.69-.12,12.52,5.43,13,12.4l13.89,191.86C1179.39,383,1174.4,388.91,1167.72,389.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "887.77 324.92 888.19 330.69 1182.1 319.36 1181.69 313.8 887.77 324.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M998.07,355.28l-73.5,3.11a.91.91,0,0,1-.94-.85l-.72-9.73a.85.85,0,0,1,.82-.92l73.5-3a.91.91,0,0,1,.93.84l.7,9.64A.83.83,0,0,1,998.07,355.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1088.19,373l-162,7.31a.91.91,0,0,1-.95-.84l-.71-9.73a.85.85,0,0,1,.81-.93l162-7.07a.89.89,0,0,1,.91.83l.69,9.53A.82.82,0,0,1,1088.19,373Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M925.59,294.21a2.72,2.72,0,0,1-1.38-.3A2.75,2.75,0,0,1,923,290.2c17.51-33.88,38.39-52.68,62.05-55.9,15-2,26.77,2.88,38.19,7.63,10.29,4.29,20.93,8.73,34.46,8.51,24.92-.43,49.59-16.85,73.26-48.89a2.75,2.75,0,0,1,4.43,3.27c-24.74,33.5-50.81,50.73-77.6,51.13-14.68.23-25.86-4.43-36.67-8.93-11.23-4.68-21.82-9.1-35.33-7.27-21.78,3-41.26,20.79-57.9,53A2.73,2.73,0,0,1,925.59,294.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1072,252.78a10.3,10.3,0,0,1-9.87,11.3,11.44,11.44,0,0,1-11.5-10.68,10.3,10.3,0,0,1,9.9-11.3A11.45,11.45,0,0,1,1072,252.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1062.28,265.47h-.14a12.87,12.87,0,0,1-12.94-12,12,12,0,0,1,3-9,11.39,11.39,0,0,1,8-3.77h.18a12.87,12.87,0,0,1,12.91,12,12,12,0,0,1-3,9A11.37,11.37,0,0,1,1062.28,265.47Zm-1.88-22a8.62,8.62,0,0,0-6.1,2.85,9.23,9.23,0,0,0-2.32,7,10,10,0,0,0,10.07,9.38,8.53,8.53,0,0,0,6.21-2.86,9.24,9.24,0,0,0,2.31-6.94,10,10,0,0,0-10-9.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1008.89 207.54 914.91 209.71 913.72 193.45 1007.72 191.48 1008.89 207.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1115.56 276.07 1078.57 277.27 1077.69 265.11 1114.68 263.97 1115.56 276.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M483.43,693.32,165.16,719c-8.61.7-16.09-5.16-16.7-13.07l-16.7-218.32c-.61-7.93,5.91-14.73,14.55-15.17L465.58,456c8-.42,14.91,5.42,15.48,13L496.8,678.41C497.37,686,491.39,692.68,483.43,693.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "498.46 607.39 147.5 632.15 147.98 638.48 498.92 613.46 498.46 607.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "464 546.98 181.81 564.73 176.47 494.74 458.91 479.31 464 546.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "466.78 583.92 184.73 602.94 182.84 578.25 464.98 560.05 466.78 583.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M279.37,660.55l-89.44,6.71a1,1,0,0,1-1.12-.89L188,655.71a1,1,0,0,1,1-1l89.46-6.58a1,1,0,0,1,1.1.88l.8,10.54A1,1,0,0,1,279.37,660.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M364.2,677.78,191.76,691.21a1,1,0,0,1-1.12-.88l-.82-10.66a1,1,0,0,1,1-1l172.47-13.18a1,1,0,0,1,1.08.88l.79,10.43A1,1,0,0,1,364.2,677.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M481.15,406.13c.58,7.61-5.43,14.09-13.41,14.47L148.32,435.78c-8.64.41-16.14-5.69-16.75-13.62L114.83,203.35c-.61-7.94,5.93-14.52,14.6-14.68l320.42-5.92c8-.15,15,5.91,15.53,13.53Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "478.34 340.67 126.13 353.98 126.61 360.32 478.8 346.75 478.34 340.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "282.95 184.29 295.66 351.87 302.31 351.62 289.61 184.17 282.95 184.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "260.69 286.49 160.79 289.53 154.67 209.37 254.67 207.27 260.69 286.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "263.98 329.74 164.14 333.29 161.98 305.01 261.85 301.79 263.98 329.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M218,388.28l-49.16,2.08a1.05,1.05,0,0,1-1.13-.93l-.82-10.68a1,1,0,0,1,1-1l49.17-2a1.06,1.06,0,0,1,1.12.92l.81,10.62A1,1,0,0,1,218,388.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M291.27,408.89l-120.65,5.47a1.05,1.05,0,0,1-1.13-.92l-.82-10.68a1,1,0,0,1,1-1l120.67-5.19a1,1,0,0,1,1.09.91l.78,10.43A1,1,0,0,1,291.27,408.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "356.19 324.48 328.39 325.46 319.34 205.91 347.19 205.33 356.19 324.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "402.37 322.85 374.88 323.82 365.9 204.94 393.44 204.36 402.37 322.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "448.04 321.23 420.85 322.19 411.94 203.97 439.18 203.4 448.04 321.23"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "356.19 324.48 328.39 325.46 323.69 263.39 351.52 262.61 356.19 324.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "402.37 322.85 374.88 323.82 367.98 232.53 395.51 231.87 402.37 322.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "448.04 321.23 420.85 322.19 414.8 241.87 442.02 241.17 448.04 321.23"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1185.64,636.64,920.55,658a12.93,12.93,0,0,1-13.91-12L892,447.11a12.73,12.73,0,0,1,12-13.76l265.89-13.72c6.67-.34,12.48,5,13,12l13.86,191.5A12.46,12.46,0,0,1,1185.64,636.64Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "906.46 578.6 906.88 584.36 1199.8 563.47 1199.4 557.93 906.46 578.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M993,607l-49.92,3.75a.9.9,0,0,1-.94-.82l-.71-9.72a.88.88,0,0,1,.81-1l49.93-3.67a.87.87,0,0,1,.92.82l.71,9.65A.87.87,0,0,1,993,607Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1046.76,624.61l-102.07,7.95a.87.87,0,0,1-.94-.81L943,622a.89.89,0,0,1,.81-1l102.08-7.79a.86.86,0,0,1,.92.8l.7,9.58A.87.87,0,0,1,1046.76,624.61Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "948.29 555.14 932.85 556.18 925.52 456.29 940.98 455.44 948.29 555.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "971.17 553.58 955.82 554.63 948.51 455.02 963.88 454.18 971.17 553.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "993.9 552.04 978.64 553.08 971.37 453.77 986.65 452.93 993.9 552.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1016.5 550.5 1001.34 551.53 994.09 452.52 1009.28 451.69 1016.5 550.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1038.97 548.98 1023.89 550 1016.68 451.28 1031.78 450.45 1038.97 548.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1061.31 547.46 1046.32 548.48 1039.14 450.04 1054.15 449.22 1061.31 547.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1083.52 545.95 1068.62 546.97 1061.46 448.82 1076.39 448 1083.52 545.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1105.6 544.45 1090.78 545.46 1083.66 447.6 1098.5 446.78 1105.6 544.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1127.55 542.96 1112.82 543.96 1105.72 446.39 1120.48 445.57 1127.55 542.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1149.38 541.48 1134.73 542.48 1127.66 445.18 1142.33 444.38 1149.38 541.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1171.07 540.01 1156.51 541 1149.47 443.98 1164.06 443.18 1171.07 540.01"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "948.29 555.14 932.85 556.18 929.04 504.31 944.5 503.37 948.29 555.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "971.17 553.58 955.82 554.63 950.21 478.14 965.57 477.25 971.17 553.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "993.9 552.04 978.64 553.08 973.7 485.6 988.98 484.7 993.9 552.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1016.5 550.5 1001.34 551.53 996.36 483.51 1011.54 482.61 1016.5 550.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1038.97 548.98 1023.89 550 1018.36 474.19 1033.45 473.32 1038.97 548.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1061.31 547.46 1046.32 548.48 1041.44 481.6 1056.45 480.71 1061.31 547.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1083.52 545.95 1068.62 546.97 1063.35 474.72 1078.27 473.85 1083.52 545.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1105.6 544.45 1090.78 545.46 1086.06 480.63 1100.89 479.75 1105.6 544.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1127.55 542.96 1112.82 543.96 1108 477.66 1122.74 476.79 1127.55 542.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1149.38 541.48 1134.73 542.48 1129.3 467.76 1143.96 466.91 1149.38 541.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1171.07 540.01 1156.51 541 1151.42 470.77 1165.99 469.92 1171.07 540.01"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M851.67,663.6,561.91,687a13.88,13.88,0,0,1-15.2-12.52l-15.6-208.13a13.62,13.62,0,0,1,13.19-14.43l290.65-15a13.53,13.53,0,0,1,14.14,12.47l14.75,200A13.29,13.29,0,0,1,851.67,663.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "865.86 581.52 546.27 604.07 546.72 610.1 866.28 587.31 865.86 581.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M684.18,630.17,588,637.39a1,1,0,0,1-1-.85l-.76-10.16a1,1,0,0,1,.89-1l96.23-7.08a.92.92,0,0,1,1,.85l.75,10A.93.93,0,0,1,684.18,630.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M763,646.72l-173.29,13.5a1,1,0,0,1-1-.85l-.76-10.16a1,1,0,0,1,.89-1L762.1,635a.92.92,0,0,1,1,.84l.73,9.93A.92.92,0,0,1,763,646.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M572.27,544.45a2.66,2.66,0,0,1-1.2-.22,2.76,2.76,0,0,1-1.44-3.62c9.24-21.36,20.5-33.26,33.47-35.36,8-1.29,14.18,1.44,20.17,4.08,6.34,2.8,12.33,5.45,20.93,4,6.53-1.09,9.57-3.7,13.42-7s8.41-7.23,17.23-10c9.62-3,15.72-2.07,22.79-.94a80,80,0,0,0,19.61,1.22c12.1-.76,18.44-3.72,26.47-7.46a129.58,129.58,0,0,1,22.61-8.57c17.53-4.74,36.59-5.84,56.66-3.25a2.75,2.75,0,0,1-.7,5.46c-19.36-2.5-37.7-1.45-54.52,3.11a124.1,124.1,0,0,0-21.72,8.25c-8.22,3.82-15.32,7.13-28.45,8a85.43,85.43,0,0,1-20.83-1.28c-6.64-1.06-11.88-1.9-20.26.76-7.75,2.45-11.58,5.75-15.3,8.95-4.14,3.56-8.06,6.93-16.11,8.27-10.22,1.69-17.57-1.55-24.06-4.41-5.73-2.53-10.68-4.71-17.06-3.69-11,1.79-20.85,12.59-29.29,32.11A2.74,2.74,0,0,1,572.27,544.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "829.73 559.13 731.08 565.78 728.03 524.6 826.73 518.47 829.73 559.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M628.22,480.13,576.43,483a1,1,0,0,1-1-.88L574.64,472a.92.92,0,0,1,.89-1l51.8-2.81a1,1,0,0,1,1,.87l.76,10.1A.92.92,0,0,1,628.22,480.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M942.73,432.09l-293-2.85c-8.14-.07-13.59-6.51-12.13-14.36l39.81-214.7c1.44-7.73,9.1-13.59,17.1-13.09L982.32,205c7,.43,11.66,6.63,10.41,13.84L957.92,419C956.65,426.29,949.85,432.16,942.73,432.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "972.59 358.11 654.06 349.37 652.91 355.52 971.58 363.84 972.59 358.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "876.64 202.45 848.41 358.9 854.36 359.06 882.52 202.82 876.64 202.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M802.62,389.48l-115.13-2.22a.79.79,0,0,1-.81-1L688.6,376a1.19,1.19,0,0,1,1.16-.92l115,2.53a.77.77,0,0,1,.77.93l-1.83,10.09A1.15,1.15,0,0,1,802.62,389.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M828.81,412.61l-145.66-2.08a.79.79,0,0,1-.81-1l1.93-10.36a1.19,1.19,0,0,1,1.16-.92L831,400.74a.77.77,0,0,1,.76.93l-1.81,10A1.15,1.15,0,0,1,828.81,412.61Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "973.49 260.87 889.01 256.67 895.03 223.19 979.29 228.02 973.49 260.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "959.47 340.27 874.47 337.61 886.45 270.95 971.02 274.88 959.47 340.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M769.8,252.55c13.64.67,22.72,11.94,20.3,25.14a26.42,26.42,0,0,1-4.34,10.25l26.33,14.26a60.38,60.38,0,0,0,9.6-23.12c5.47-30-15.07-55.84-46.17-57.59h-.25l-5.72,31.07A2.08,2.08,0,0,1,769.8,252.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M785.76,287.94c-5.47,7.89-15,13.15-24.83,12.77-13.78-.54-23-11.85-20.57-25.2s15.55-23.51,29.19-23l5.72-31.07c-31.44-1.63-61.94,21.87-67.66,52.59-5.75,30.87,15.77,56.86,47.57,57.87,22.72.72,44.53-11.54,56.91-29.74Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1370.61,254.39V108.56h58.33v29.16h-29.16v87.5h29.16v29.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1441.31,235.78V137.07h7v-7h70.51v21.15h-56.41v21.15h35.26v21.16h-35.26v42.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1525.92,235.78V130h70.51v7h7.06v42.31h-7.06v7.05h7.06v49.35h-21.16v-42.3h-35.25v42.3Zm56.41-63.46V151.17h-35.25v21.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1617.59,235.78v-7.05h-7V137.07h7v-7h63.46v7h7v91.66h-7v7.05ZM1667,214.63V151.17h-35.26v63.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1695.15,235.78V130h21.15v7h7v14.1h7.06v14.1h7v14.11h7v7.05h7V130h21.15V235.78h-21.15v-7.05h-7v-14.1h-7v-14.1h-7v-14.1h-7.06v-7.05h-7v56.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1808,235.78V151.17h-28.21V130h77.57v21.15h-28.21v84.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1871.43,235.78v-7.05h-7V137.07h7v-7h70.51v21.15h-56.41v21.15h35.26v21.16h-35.26v21.15h56.41v21.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1949,235.78V130h21.15v7h7v14.1h7.06v14.1h7v14.11h7v7.05h7.05V130h21.15V235.78H2005.4v-7.05h-7.05v-14.1h-7v-14.1h-7v-14.1h-7.06v-7.05h-7v56.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2033.6,235.78V130h70.51v7h7.06v91.66h-7.06v7.05ZM2090,214.63V151.17h-35.25v63.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1392,371.17V265.4h70.51v7.05h7v91.67h-7v7.05ZM1448.36,350V286.55h-35.25V350Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1483.62,371.17v-7.05h-7V272.45h7V265.4h70.51v21.15h-56.41v21.16H1533v21.15h-35.25V350h56.41v21.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1589.38,371.17v-7.05h-7.05V350h-7V343h-7v-14.1h-7V265.4h21.15v63.46h7.05V343h7V350h7.06V343h7v-14.1h7V265.4h21.15v63.46h-7V343h-7V350h-7.05v14.11h-7v7.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1652.84,371.17v-7.05h-7V272.45h7V265.4h70.51v21.15H1667v21.16h35.25v21.15H1667V350h56.4v21.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1737.46,371.17v-7.05h-7V265.4h21.15V350H1808v21.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1822.07,371.17v-7.05h-7V272.45h7V265.4h63.46v7.05h7v91.67h-7v7.05ZM1871.43,350V286.55h-35.26V350Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1899.63,371.17V265.4h70.51v7.05h7v49.36h-7v7.05h-49.35v42.31ZM1956,307.71V286.55h-35.25v21.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1991.3,371.17v-7.05h-7V272.45h7V265.4h70.51v21.15H2005.4v21.16h35.25v21.15H2005.4V350h56.41v21.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2068.86,371.17V265.4h70.51v7.05h7.05v42.31h-7.05v7.05h7.05v49.36h-21.15V328.86H2090v42.31Zm56.41-63.46V286.55H2090v21.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1434,503.15V472.3h-15.42V426h46.27v61.69h-15.43v15.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1452.16,641.93v-7h-7.05V543.21h7.05v-7.05h63.46v7.05h7.05v21.16h-21.16v-7h-35.25v63.46h35.25V599.62h-14.1V578.47h28.21v7h7.05v49.36h-7.05v7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1529.72,641.93V536.16h70.51v7.05h7v42.31h-7v7.05h7v49.36h-21.15V599.62h-35.26v42.31Zm56.41-63.46V557.32h-35.26v21.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1614.33,641.93V543.21h7.05v-7.05h63.46v7.05h7.05v98.72h-21.15V599.62h-35.25v42.31Zm56.41-63.46V557.32h-35.25v21.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1699,641.93V536.16h70.51v7.05h7v49.36h-7v7H1720.1v42.31Zm56.4-63.46V557.32H1720.1v21.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1783.56,641.93V536.16h21.15v42.31H1840V536.16h21.15V641.93H1840V599.62h-35.26v42.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1868.17,641.93V536.16h21.16V641.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1903.43,641.93v-7h-7V543.21h7v-7.05h63.46v7.05h7v21.16h-21.15v-7h-35.26v63.46h35.26v-7.06h21.15v21.16h-7v7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1445.11,777.31V671.54h70.51v7.05h7.05v91.67h-7.05v7Zm56.4-21.15V692.7h-35.25v63.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1536.77,777.31v-7h-7V678.59h7v-7.05h70.51V692.7h-56.41v21.15h35.26V735h-35.26v21.16h56.41v21.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1621.38,777.31v-7h-7.05V749.1h21.16v7.06h35.25V735h-49.36v-7h-7.05V678.59h7.05v-7.05h63.46v7.05h7.05v21.16h-21.15v-7h-35.25v21.15h49.35v7h7.05v49.36h-7.05v7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1699,777.31V671.54h21.15V777.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1734.2,777.31v-7h-7V678.59h7v-7.05h63.46v7.05h7v21.16h-21.15v-7H1748.3v63.46h35.26V735h-14.1V713.85h28.2v7h7v49.36h-7v7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1811.76,777.31V671.54h21.16v7.05h7V692.7h7v14.1h7v14.1h7V728h7.05V671.54h21.16V777.31h-21.16v-7h-7.05v-14.1h-7V742.05h-7V728h-7V720.9h-7v56.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1903.43,777.31v-7h-7V678.59h7v-7.05h70.51V692.7h-56.41v21.15h35.26V735h-35.26v21.16h56.41v21.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1981,777.31V671.54h70.51v7.05h7.05V720.9h-7.05V728h7.05v49.36H2037.4V735h-35.26v42.31Zm56.41-63.46V692.7h-35.26v21.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2125.52,651.76V797.59h-58.33V768.42h29.17v-87.5h-29.17V651.76Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntro);
export default __webpack_public_path__ + "static/media/intro.6b26ac5ba0c3f1d3100f1f71fded5880.svg";
export { ForwardRef as ReactComponent };